<template>
  <div class="recipes-component">
    <div class="area">
      <div class="row recipes-container" v-animated-show="utils.handleScroll">
        <h1 v-html="title" class="component-title col-12 centered"></h1>
        <div class="recipes-list col-12 col-md-12" ref="animated" id="recipes">
          <section
            class="list-section-banner"
            v-for="(l, i) in list"
            :key="i"
            :class="[
              {
                current: current === i,
                'animated-banner': list.length > 1,
              },
            ]"
            :id="'recipe-id-' + i"
            :style="{
              transform: translate,
            }"
          >
            <div class="row">
              <div class="spacer col-1 md-hidden"></div>
              <div class="content col-5 col-md-12">
                <Description
                  class="default icon-top icon-top-small"
                  :isMoreTop="true"
                  :title="l.title"
                  :desc="l.desc"
                  v-if="l.title"
                />
                <Description
                  class="mini icon-top icon-top-small"
                  :isMoreTop="true"
                  :title="l.recipe.title"
                  :desc="l.recipe.desc"
                />
              </div>
              <div class="art col-6 col-md-12">
                <div class="crumbs"></div>
                <img :src="l.img.src" :alt="l.img.alt" />
              </div>
            </div>
          </section>
        </div>
        <div class="nav-arrows">
          <a
            v-if="list.length > 1"
            class="nav-arrow nav-arrow--next"
            href="/"
            @click.prevent="
              () => {
                selectNav(current + 1);
              }
            "
          ></a>
          <a
            v-if="list.length > 1"
            class="nav-arrow nav-arrow--prev"
            href="/"
            @click.prevent="
              () => {
                selectNav(current - 1);
              }
            "
          ></a>
        </div>
        <div class="row-offset">
          <ShareWidget
            class="col-12 col-12-md gap-offset"
            theme="share"
            :printId="recipeId"
            >Поделиться</ShareWidget
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShareWidget from "../components/ShareWidget";
import utils from "../utils";
export default {
  name: "Recipes",
  props: {
    title: String,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      current: 0,
    };
  },
  computed: {
    translate() {
      return `translateX(-${this.currentBanner * 100}%)`;
    },
    recipeId() {
      return "recipe-id-" + this.current;
    },
  },
  methods: {
    selectNav(index) {
      this.current = (index + this.list.length) % this.list.length;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.animated) {
        this.$refs.animated.classList.add("animated");
      }
    }, 1000);
  },
  components: {
    ShareWidget,
  },
};
</script>

<style lang="scss">
.recipes-component {
  @extend %page-block;
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
  .recipes-container {
    display: grid;
    grid-row-gap: 46px;
  }
  h1 {
    @media all and (max-width: $md) {
      margin-bottom: 0;
    }
  }
  h2 {
    margin-bottom: 35px;
  }
  .recipes-list {
    @media all and (max-width: $md) {
      margin-top: -26px;
    }
    display: grid;
    grid-row-gap: 36px;
    grid-row: 2;
    grid-column: 1 / span 12;
    .list-section-banner {
      > .row {
        @media all and (max-width: $md) {
          grid-row-gap: 26px;
        }
      }

      grid-row: 1;
      grid-column: 1 / span 12;
      position: relative;
      visibility: hidden;
      z-index: 0;
      &.animated-banner {
        @extend %switch-anim;
      }
      &.current {
        visibility: visible;
        display: grid;
        z-index: 1;
      }
      .content {
        @media all and (max-width: $md) {
          margin-left: 0px;
          grid-gap: 26px;
        }
        display: grid;
        grid-gap: 56px;
        margin-left: -26px;
      }
      .description.mini {
        .desc {
          line-height: 1.5em;
        }
      }
    }
    &.animated {
      .list-section-banner {
        visibility: visible;
      }
    }
  }

  .art {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      grid-row: 1;
      mask-size: contain;
      background-size: cover;
      height: 280px;
      max-height: 280px;
      margin-left: 0;
      margin-top: 0;
      justify-content: center;
      overflow: hidden;
    }
    height: 440px;
    position: relative;
    align-items: stretch;
    align-self: flex-start;
    display: grid;
    margin-left: 26px;
    margin-top: -26px;
    justify-content: center;
    .crumbs {
      @media all and (max-width: $md) {
        left: -60px;
        top: -60px;
        right: -60px;
        bottom: -30px;
      }
      position: absolute;
      left: -60px;
      top: -60px;
      right: -60px;
      bottom: -100px;
      z-index: -1;
    }
    img {
      -webkit-mask: url(../assets/photos/main/recepit_mask.svg) center center
        no-repeat;
      mask: url(../assets/photos/main/recepit_mask.svg) center center no-repeat;
      mask-size: contain;
      @media all and (max-width: $md) {
        max-height: 280px;
        align-self: stretch;
        object-fit: cover;
      }
      object-fit: cover;
      max-width: 100%;
    }
  }
  .nav-arrows {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      grid-row: 2;
      z-index: 2;
      height: 280px;
    }
    z-index: 3;
    grid-row: 2;
    grid-column: 7 / span 6;
    position: relative;
    height: 440px;
    .nav-arrow {
      position: absolute;
      top: 50%;

      @media all and (max-width: $md) {
        top: 50%;
      }
      transform: translate(0, -50%);
      &.nav-arrow--prev {
        @media all and (max-width: $lg) {
          left: 2px;
        }
        @media all and (max-width: $md) {
          left: -8px;
        }
        left: 0px;
      }
      &.nav-arrow--next {
        @media all and (max-width: $lg) {
          right: 2px;
        }
        @media all and (max-width: $md) {
          right: -8px;
        }
        right: 0px;
      }
    }
  }
  .description.mini {
    .desc {
      @media all and (max-width: $md) {
        margin-right: 0;
      }
      margin-right: 45px;
    }
  }
}
</style>
